import * as React from 'react';
import { IBank } from '../../types/newbuilding/bank';

import * as styles from './styles.css';

export interface IBankProps extends IBank {
  onClick(url: string): void;
}

export const Bank = ({ searchUrl, logoUrl, seoTitle, onClick }: IBankProps) => {
  return (
    <a className={styles['bank']} target="_blank" rel="noreferrer" href={searchUrl} onClick={() => onClick(searchUrl)}>
      <div className={styles['img']} style={{ backgroundImage: `url(${logoUrl})` }} title={seoTitle} />
    </a>
  );
};

Bank.displayName = 'Bank';
